import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { action, computed } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import { withRouter } from 'react-router'
import classnames from 'classnames'
import inject from 'helpers/inject'

import { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'

import RouterService from 'services/router'

import styles from 'styles/components/NavListItem'

@withStyles(styles)
@withRouter
@observer
export default class NavListItem extends Component {

  static propTypes = {
    route: PropTypes.shape({
      navLinkTitle: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    }).isRequired,
    onClick: PropTypes.func
  }

  router = inject(RouterService)

  @computed
  get isActive() {
    const { route, location } = this.props
    const isMatchExactly = location.pathname === route.path
    const isContaining = location.pathname.indexOf(route.path) > -1
    return route.exact ? isMatchExactly : isContaining
  }

  render() {
    const { route, classes } = this.props

    return (
      <ListItem
        button
        className={ classnames(classes.navLink, { [classes.navLinkActive]: this.isActive }) }
        onClick={ this.handleClick }
      >
        { route.navLinkIcon &&
          <ListItemIcon className={ classes.navLinkIcon }>
            <route.navLinkIcon />
          </ListItemIcon>
        }
        <ListItemText primary={ route.navLinkTitle } />
      </ListItem>
    )
  }

  @action.bound
  handleClick() {
    const { route, onClick } = this.props
    if (!this.isActive) {
      this.router.transitionTo(route)
      if (onClick) onClick()
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/NavListItem.js